import { IconHistory } from "@tabler/icons-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useGetApi } from "../../../hooks";
import type { ISearchResult } from "../../../pages/SearchPage/SearchPage.types";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { setURNHistoryModalData } from "../../../redux/slices/generatorFeaturesSlice";
import { StyledActionIcon } from "../../../styled";
import { getYachtId } from "../../../utils";
interface Props {
  urn: number;
  userName?: string;
}
const URNHistoryButton = ({ urn, userName }: Props) => {
  const dispatch = useDispatch();
  const { collectionId } = useSelector(state => state.generatorSlice);
  const { data, refetch, isLoading } = useGetApi<{
    success: boolean;
    data: ISearchResult[];
  }>({
    request: "search-urn-olb",
    fetchOnInit: false,
    body: {
      params: {
        urn: String(urn),
        colid: collectionId,
        yachtid: getYachtId(),
      },
    },
  });
  const handleOpen = () => {
    if (collectionId) void refetch();
  };
  useEffect(() => {
    if (data?.success) {
      dispatch(setURNHistoryModalData({ urn, userName, data: data.data }));
    }
  }, [data]);
  if ((window.api && !window.navigator.onLine) || !urn) {
    return;
  }
  return (
    <StyledActionIcon onClick={handleOpen} loading={isLoading}>
      <IconHistory />
    </StyledActionIcon>
  );
};
export default URNHistoryButton;
